import { IconToggle } from "@/design-system/IconToggle/IconToggle";
import { NewTag } from "@/design-system/Tags/NewTag/NewTag";
import { useTranslation } from "@repo/shared/i18n";
import { Equal, Grip } from "lucide-react";
import { useLocalStorage } from "usehooks-ts";

export type PlayersView = "list" | "grid";

/** List or grid. Evolution players remember theirs apart from players. */
export const usePlayersView = (
  storageKey: "players-view" | "evolution-players-view" = "players-view",
) => useLocalStorage<PlayersView>(storageKey, "list");

export const PlayersViewToggle = ({
  value,
  onChange,
}: {
  value: PlayersView;
  onChange: (view: PlayersView) => void;
}) => {
  const { t } = useTranslation("players");
  return (
    <div className="flex items-center gap-x-2">
      {/* No room for it in the phone band. */}
      <span className="max-mobile:hidden">
        <NewTag />
      </span>
      <IconToggle
        value={value}
        onChange={onChange}
        options={[
          {
            value: "list",
            label: t("toolbar.listView"),
            icon: <Equal className="size-4" strokeWidth={3} />,
          },
          {
            value: "grid",
            label: t("toolbar.gridView"),
            icon: <Grip className="size-4" />,
          },
        ]}
      />
    </div>
  );
};
